import React from 'react';
import { CssBaseline, Grid, Chip } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import { EVENT_IMG } from '../constatns';
// import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  chipBox: {
    width: '100%',
    display: 'block',
    minHeight: '158px',
  },
  chips: {
    color: 'white',
    width: '100%',
    height: '30px',
    borderRadius: '0',
  },
  imgBoxDiv: {
    textAlign: 'center',
    width: '100%',
  },
  imgBox: {
    // width: '350px',
    // height: '90px',
    // lineHeight: '90px',
    // border: '1px solid #ebebeb',
    textAlign: 'center',
    margin: '10px 3px',
    verticalAlign: 'middle',
    display: 'inline-block',
  },
  logo: {
    cursor: 'pointer',
    verticalAlign: 'middle',
  },
  standardBox: {
    width: '225px',
    height: '65px',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
    lineHeight: '65px',
    border: '1px solid #ebebeb',
    textAlign: 'center',
    margin: '10px 3px',
    verticalAlign: 'middle',
    display: 'inline-block',
  },
});

class SponsorList extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={5} SIdx={2} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Sponsors</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <div style={{}}>
                <span className={classes.chipBox}>
                  <Chip
                    className={classes.chips}
                    style={{
                      backgroundImage: `url('/images/PRS2022/sponsor/dia_bg.png')`,
                      backgroundRepeat: 'none',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: 'bold',
                      padding: '24px 0',
                    }}
                    label="DIAMOND"
                  />
                  <div className={classes.imgBoxDiv}>
                    <div className={classes.imgBox} style={{ width: '420px', height: '140px' }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/dia_01.png`}
                        alt="lncbioLogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('http://www.lncbio.co.kr/');
                        }}
                      />
                    </div>
                  </div>
                </span>

                <span className={classes.chipBox}>
                  <Chip
                    className={classes.chips}
                    style={{
                      backgroundImage: `url('/images/PRS2022/sponsor/platinum_bg.png')`,
                      backgroundRepeat: 'none',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: 'bold',
                      padding: '24px 0',
                    }}
                    label="PLATINUM"
                  />
                  <div className={classes.imgBoxDiv}>
                    <div className={classes.imgBox} style={{ width: '380px', height: '100px' }}>
                      <img
                        src="/images/PRS2021/motivaLogo.png"
                        alt="motivaLogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%' }}
                        onClick={() => {
                          window.open('http://motivaimplants.co.kr/');
                        }}
                      />
                    </div>
                  </div>
                </span>

                <span className={classes.chipBox}>
                  <Chip
                    className={classes.chips}
                    style={{
                      backgroundImage: `url('/images/PRS2022/sponsor/silver_bg.png')`,
                      backgroundRepeat: 'none',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: 'bold',
                      padding: '24px 0',
                    }}
                    label="SILVER"
                  />
                  <div className={classes.imgBoxDiv}>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_01.png`}
                        alt="cgbioLogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'default' }}
                        // onClick={() => {
                        //   swal('', 'To be updated', 'info');
                        // }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_02.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('http://www.hansbiomed.com/');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_03_b.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'default' }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_04.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('https://www.trmkorea.com/');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_05.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('http://planbio.co.kr/');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_06.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('https://www.jnjmedtech.com/ko-KR ');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_07.png`}
                        alt="jnjLogo"
                        className={classes.logo}
                        style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('https://www.cgbio.co.kr/');
                        }}
                      />
                    </div>
                  </div>
                </span>
                <span className={classes.chipBox}>
                  <Chip
                    className={classes.chips}
                    style={{
                      backgroundImage: `url('/images/PRS2022/sponsor/bronze_bg.png')`,
                      backgroundRepeat: 'none',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: 'bold',
                      padding: '24px 0',
                    }}
                    label="BRONZE"
                  />
                  <div className={classes.imgBoxDiv}>
                    <div className={classes.imgBox} style={{ width: '300px', height: '80px' }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/bronze_01.png`}
                        alt="allolifeLogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('http://www.allolife.com/default/');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox} style={{ width: '300px', height: '80px' }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/bronze_02.png`}
                        alt="MSB_Logo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('https://osteonic.com/');
                        }}
                      />
                    </div>
                    <div className={classes.imgBox} style={{ width: '300px', height: '80px' }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/bronze_03.png`}
                        alt="daewoonglogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('http://msbio.co.kr/');
                        }}
                      />
                    </div>

                    <div className={classes.imgBox} style={{ width: '300px', height: '80px' }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/bronze_04.png`}
                        alt="daewoonglogo"
                        className={classes.logo}
                        style={{ width: 'auto', height: '80%', cursor: 'pointer' }}
                        onClick={() => {
                          window.open('https://www.ildong.com/kor/main/main.id');
                        }}
                      />
                    </div>
                  </div>
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(SponsorList));
